<template>
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item active">Card</li>
    <li class="breadcrumb-item">{{ $route.meta.title }}</li>
  </ol>
</template>

<script>
export default {
name: "Breadcumb"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Breadcumb.vue